import logo from './logo.svg';
import './App.css';
import "assets/css/App.css"
import "assets/css/Contact.css"
import "assets/css/MiniCalendar.css"
import Main from './Pages/Main/Main';
import { Route,Routes,Navigate } from 'react-router-dom';
import Form from './Pages/Form/Form';
import 'react-phone-input-2/lib/style.css'
import Login from 'Pages/Login/Login';
import Profile from 'Pages/Profile/Profile';
import ProtectedRoute from 'Component/ProtectedRoute/ProtectedRoute';
import { useNavigate } from 'react-router-dom';
import LoginProtected from 'Component/LoginProtected';
import ForgotPassword from 'Pages/ForgotPassword/ForgotPassword';
import NewPassword from 'Pages/NewPassword/NewPassword';
import VideoSection from 'Pages/VideoSection/VideoSection';
import DocumentProtection from 'Component/ProtectedRoute/DocumentProtection';
import PublicProfile from 'Pages/PublicProfile/PublicProfile';
import Notifications from 'Pages/Notifications/Notifications';
import EditProfile from 'Pages/Profile/EditProfile';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from 'Layout/Footer';
import { useLocation } from 'react-router-dom';
import AddAccount from 'Pages/Account/AddAccount';
function App() {
 const token  = localStorage.getItem("token")
 const stripePromise = loadStripe('pk_test_51KNqB0JZCU3jloCMl9cTsICBXkvA3djFelJWKoXrXPVtyy9asoEAfokBBiXDQCZle5gZrIwc9g9lA4eRqsP6Kwrg008cp0bB7T');
  const location = useLocation()

  const options = {
    clientSecret: 'sk_test_51KNqB0JZCU3jloCMqKIIYoS3tQIv7VrikT8ESubEviTaMXSdVDibGGqmUgX66k6eH4WhBoS4WmbhncE5e8VmkfKp00aO3xUD6p',
  }
  const path = location.pathname;
  const isPublicProfilePage = /^\/driver_forms\/profile\/[a-f0-9]+$/i.test(path) || path.startsWith("/driver_forms/public_profile");
  const showFooter = (path.includes("submit") || path.includes("profile")) && !isPublicProfilePage;
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Elements stripe={stripePromise}>
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path='/driver_forms' element={<Main />} />
            <Route path='/:label' element={<Form />} />
            <Route path='/driver_forms/login' element={<LoginProtected><Login /></LoginProtected>} />
            <Route path='/driver_forms/profile/:id' element={<PublicProfile />} />
            <Route path='/driver_forms/profile' element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path='/driver_forms/forgot_password' element={<ForgotPassword />} />
            <Route path='/driver_forms/new_password/:token' element={<NewPassword />} />
            <Route path='/driver_forms/submit/' element={<DocumentProtection><VideoSection /></DocumentProtection>} />
            <Route path='/driver_forms/public_profile/' element={<PublicProfile />} />
            <Route path='/driver_forms/notifications/' element={<ProtectedRoute ><Notifications /></ProtectedRoute>} />
            <Route path='/driver_forms/profile/edit' element={<ProtectedRoute ><EditProfile /></ProtectedRoute>} />
            <Route path='/driver_forms/account/add' element={<ProtectedRoute ><AddAccount /></ProtectedRoute>} />
          </Routes>
        </main>
        {showFooter && <Footer />}
      </Elements>
    </div>
  );
}

export default App;
